import * as angular from 'angular';
import {IController, IRootScopeService, IScope} from "angular";
import * as _ from "lodash";

export class serviceListItemCtrl implements IController {
  id: any;
  siteMarketMode: any;
  checked: any;
  onToggle: Function;

  private delivery: any;
  private openPriceSection: any;

  /* @ngInject */
  constructor(private $delivery, private $scope: IScope, private $rootScope: IRootScopeService, private mapConstant) {
  }

  $onInit() {
    this.openPriceSection = false;
    this.$delivery(this.id).$bindCtrlToId(this.$scope, this, 'delivery', 'id');

    this.$rootScope.$on('highlight-stopover-from-marker',(event, taskId) => {
      this.selectDeliveryCard(taskId)
    });

    this.$rootScope.$on('highlight-stopover-from-delivery',(event, taskId) => {
      this.selectDeliveryCard(taskId)
    });

  }

  checkBoxClick() {
    if (this.siteMarketMode && !_.isUndefined(this.delivery)) {
      this.$rootScope.$broadcast(this.mapConstant.events.siteMarket.taskMarkersBounce, this.delivery.taskIdList)
    }
    this.onToggle({id: this.id});
  };

  collapsePriceSection($event) {
    $event.stopPropagation();
    this.openPriceSection = !this.openPriceSection;
  };

  private selectDeliveryCard(taskId) {
    if (this.delivery) {

      var taskIndex = _.findIndex(this.delivery.taskIdList, (deliveryTaskId) => {
        return _.isEqual(deliveryTaskId, taskId)
      });
      this.checked = !_.isEqual(taskIndex, -1);
    }
  }


}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceListItem', {
    bindings: {
      id: '<',
      siteMarketMode: '<',
      checked : '<?',
      onToggle : '&'
    },
    template: require('./service-list-item.html').default,
    controller: serviceListItemCtrl
  });

